"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inventorySync = void 0;
const store_1 = require("client/modules/inventory/modules/inventory-create/store");
const store_2 = require("client/modules/inventory/modules/inventory-list/store");
const mobx_1 = require("mobx");
const store_3 = require("../../../../sites/modules/sites-list/store");
/**
 * Imports inventory.json files from pharmacies to be passed to the database.
 * Files must be stored in data/sheets/${siteFolder} to be valid.
 *
 * @param siteFolder Name of the folder to extract json files from.
 * @returns A Promise.All() of process-pending inventory items.
 */
exports.inventorySync = (siteFolder) => {
    /** The json object representing individual rows from our excel sheet. */
    const rows = require(`../../../../../../../data/sheets/${siteFolder}/inventory.json`);
    /** Hardcoded rows to skip represented by their literal row number. */
    const skipRows = [1];
    /** A collection of our already existing sites in the database. */
    const { sites: { value: sites = [] } } = store_3.sitesListStore;
    /** A map representing the site name and real location in the database. */
    const sitesMap = {
        name: sites.map((site) => site.displayName),
        pos: sites.map((site) => site.id),
    };
    /** Placeholder storage of our existing inventory pulled from the database. */
    const existingInventory = {
        meds: [],
        ndcs: [],
    };
    /** The ID of the site we're working with, populated from the site map. */
    let siteId;
    /** Collect the current existing inventory and populate the placeholder. */
    const getInventory = store_2.inventoryListStore
        .loadInventory()
        .then(() => Object.values(mobx_1.toJS(store_2.inventoryListStore.inventory.value)).forEach(item => item.children.forEach(med => {
        existingInventory.meds.push(med);
        existingInventory.ndcs.push(med.ndc);
    })));
    /**
     * Return a promise of inventory items to conditionally be created and
     * linked.
     *
     * Our Object.value map iterates over each line in the spreadsheet, strips
     * the NDC Package number, and compares it against our existing inventory.
     * If the package already exists we immediately link the two ids together,
     * otherwise we need to create the inventory item before linking them together.
     *
     * @returns A promise awaiting site-to-inventory connection.
     */
    return getInventory.then(() => Promise.all(Object.values(rows.inventory).map(async (row, i) => {
        if (row.NDC !== undefined && skipRows.indexOf(i + 1) === -1) {
            const price = row.cost;
            const ndcSections = row.NDC.trim().split('-');
            const ndc = `${ndcSections[0]}-${ndcSections[1]}`;
            const ndcPackage = `${ndcSections[0]}-${ndcSections[1]}-${ndcSections[2]}`;
            const ndcList = existingInventory.ndcs;
            const meds = existingInventory.meds;
            let inventoryId;
            if (ndcList.indexOf(ndc) === -1) {
                const createdId = await store_1.inventoryCreateStore.pullPackage(ndcPackage);
                inventoryId = createdId;
            }
            else {
                meds.forEach((med) => {
                    if (med.package === ndcPackage) {
                        inventoryId = med.id;
                    }
                });
            }
            const inventoryData = {
                inventoryId,
                price,
            };
            return store_1.inventoryCreateStore.connectInventorytoSite(inventoryData, siteId);
        }
        else if (i === 0) {
            const siteName = row.siteName;
            siteId = sitesMap.name.indexOf(siteName);
            siteId = sitesMap.pos[siteId];
        }
        return null;
    })));
};



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/sync/modules/google-sync/modules/google-inventory.ts
// module id = 4132
// module chunks = 0